import React from "react";
import SectionTitle from "../../components/SectionTitle";
import reduximg from "../../images/redux.png";
import cssimg from "../../images/css.png";
import htmlimg from "../../images/html.png";
import nodeimg from "../../images/node.png";
import figmaimg from "../../images/figma.png";
import jsimg from "../../images/js.png";
import mongomg from "../../images/mong-removebg-preview.png";
import sass from "../../images/sass.png";
import reactjs from "../../images/react.png";
import tailwindImg from "../../images/Tailwind_CSS_Logo.svg";
import WithHelmet from "../../utils/WithHelmet";
// import { AiFillCaretRight } from "react-icons/ai";

// import tailwindImg from "../../images/tailwindbg.png";

// meta tags
const pageTitle = "Learn About Md Shahar Shitol | Full-Stack Web Developer";
const description =
  "Discover the story behind Md Shahar Shitol, a passionate full-stack web developer with expertise in creating dynamic and user-friendly web applications. Learn about his skills, experience, and dedication to delivering high-quality solutions.";
const keywords = [
  "about me",
  "full-stack web developer",
  "skills",
  "experience",
  "high-quality solutions",
  "md shahar shitol",
  "frontend developer",
  "hire me",
];
const Aboutme = () => {
  const skills = [
    { name: "React", img: reactjs },
    { name: "Redux", img: reduximg },
    { name: "Tailwind", img: tailwindImg },
    { name: "Node", img: nodeimg },
    { name: "MongoDB", img: mongomg },
    { name: "SASS", img: sass },
    { name: "Javascript", img: jsimg },
    { name: "Figma", img: figmaimg },
    { name: "CSS", img: cssimg },
    { name: "HTML", img: htmlimg },
  ];
  return (
    <div
      className="md:p-10 p-3 py-10 mb-16  mx-auto"
      data-aos="fade-right"
      data-aos-offset="200"
      data-aos-delay="50"
      data-aos-duration="700"
      data-aos-easing="ease-in-out"
    >
      <SectionTitle>About me</SectionTitle>
      <h1 className="text-3xl text-neutral font-bold capitalize">
        Not your another web developer
      </h1>
      <div className="text-center mt-16 leading-loose tracking-widest">
        <h1 className="text-2xl my-6">
          Hello, I'm <span className="font-bold">Md Shahar Shitol</span>
        </h1>
        {/* <p className="mt-5 md:mt-2">
          I'm a am a 22-year-old <span className="font-bold">Fullstack</span>{" "}
          DEVELOPER. Over the course of a year, I've self-taught myself a
          variety of web programming skills.
        </p> */}
        <p className="mt-5 md:mt-2">
          I'm a 22-year-old{" "}
          <span className="font-bold text-accent">Fullstack</span> developer
          with a passion for web development. Through self-teaching and
          continuous learning, I have acquired a diverse range of web
          programming skills over the past year. Led and managed intensive
          projects for two clients, demonstrating a strong commitment to
          delivering high-quality work and ensuring client satisfaction.
        </p>
      </div>
      <div className="">
        <div className="grid grid-cols-1 gap-5">
          {/* skills */}
          <div className=" mt-10">
            <div className="divider before:bg-accent/40  after:bg-accent/40 col-span-2 uppercase font-bold lg:w-2/3 mx-auto">
              Skills
            </div>
            <div className="flex flex-wrap gap-x-14 gap-y-5 w-auto mx-auto md:w-2/3 justify-center items-center ">
              {skills.map((skill) => (
                <div className="flex flex-col items-center" key={skill.name}>
                  <div className="p-3 rounded-full">
                    <img
                      src={skill.img}
                      width="50"
                      alt={`${skill.name} tech icon`}
                    />
                  </div>
                  <small>{skill.name}</small>
                </div>
              ))}
            </div>
          </div>

          {/*  */}
          {/* <div className="mt-5 md:mt-0 mx-auto">
            <div className="grid grid-cols-3 gap-0 items-center">
              <div className="md:justify-self-center">
                <div className="mb-2 font-bold">Name:</div>
                <div className="my-2 font-bold">Address:</div>
                <div className="my-2 font-bold">Study:</div>
                <div className="my-2 font-bold">Degree:</div>
                <div className="my-2 font-bold">Email:</div>
                <div className="my-2 font-bold">Phone:</div>
              </div>
              <div className="col-span-2">
                <div className="mb-2">Md Shahar Shitol</div>
                <div className="my-2">Dhaka, Bangladesh</div>
                <div className="my-2">Jahangirnagar University</div>
                <div className="my-2">BBA</div>
                <div className="my-2">mdsaharshitol@gmail.com</div>
                <div className="my-2">+8801642413652</div>
              </div>
            </div>
          </div> */}
          {/*  */}

          {/* <div className="mt-10">
            <div className="divider col-span-2 uppercase font-bold">Interests </div>
            <ul className="mt-7 ml-0 md:ml-[4vw]">
              <li className="flex items-center mb-3">
                <AiFillCaretRight />
                Travel & Trekking
              </li>
              <li className="flex items-center mb-3">
                <AiFillCaretRight />
                Cinematography
              </li>
              <li className="flex items-center mb-3">
                <AiFillCaretRight />
                Reading
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default WithHelmet(Aboutme, pageTitle, description, keywords);
